const DifferenceCheckerIcon = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={30}
            height={30}
            fill="none"
            {...props}
        >
            <rect width={30} height={30} fill="#fff" rx={3} />
            <path
                fill="#8790A4"
                d="M14.083 24.376v-2.044H9.148c-.422 0-.775-.141-1.057-.424a1.438 1.438 0 0 1-.424-1.057V9.147c0-.423.141-.775.424-1.057a1.44 1.44 0 0 1 1.057-.425h4.935V5.621H15v18.755h-.917ZM17.01 8.582v-.917h4.02c.421 0 .774.142 1.057.425.283.283.424.635.423 1.057v11.705c0 .421-.141.773-.423 1.056a1.43 1.43 0 0 1-1.057.424h-4.02v-.917h4.02a.54.54 0 0 0 .387-.176.535.535 0 0 0 .177-.388V9.147a.542.542 0 0 0-.177-.39.534.534 0 0 0-.387-.175h-4.02Zm0 6.875v-.917h3.209v.917h-3.209Zm0-3.208v-.917h3.209v.917h-3.209Zm-6.134 6.416h3.208v-.916h-3.208v.916Zm0-3.208h3.208v-.917h-3.208v.917Zm0-3.208h3.208v-.917h-3.208v.917Z"
            />
        </svg>
    )
}

export default DifferenceCheckerIcon